import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as orderActions from '../../../actions/orderActions';
import OrderModalStep from '../OrderModalStep/OrderModalStep';
import PaymentTypeSelector from '../../common/PaymentTypeSelector/PaymentTypeSelector';
import OrderSummary from '../OrderSummary/OrderSummary';
import './PaymentStep.less';

class PaymentStep extends React.Component {
  constructor(props) {
    super(props);

    this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
  }

  handlePaymentTypeChange(type) {
    this.props.orderActions.changePaymentType(type);
  }

  render () {
    const {handlePaymentTypeChange} = this;
    const {paymentType, address, cartItems, onPrimaryAction, onBack, onClose} = this.props;
    const primaryActionTitle = paymentType === 'online' ? 'Plać >>' : 'Zatwierdź >>';
    //TODO: remove as payment gate will be ready
    const primaryActionEnabled = paymentType === 'cash';

    return (
      <OrderModalStep className="payment-step"
        title="Płatność"
        primaryActionTitle={primaryActionTitle}
        primaryActionEnabled={primaryActionEnabled}
        onPrimaryAction={onPrimaryAction}
        onBack={onBack}
        onClose={onClose}>
        <div>
          <PaymentTypeSelector type={paymentType} onChange={handlePaymentTypeChange} />
          {paymentType === 'online' && <p className="secondary">Płatność będzie wykonywana przez PayU</p>}
        </div>
        <aside>
          <OrderSummary address={address} cartItems={cartItems}/>
        </aside>
      </OrderModalStep>
    );
  }
}

PaymentStep.propTypes = {
  paymentType: PropTypes.string,
  address: PropTypes.object,
  cartItems: PropTypes.array,
  orderActions: PropTypes.object.isRequired,
  onPrimaryAction: PropTypes.func,
  onBack: PropTypes.func,
  onClose: PropTypes.func
};

function mapStateToProps(state) {
  return {
    paymentType: state.order.paymentType,
    address: state.address,
    cartItems: state.cart.cartItems
  };
}

function mapDispatchToProps(dispatch) {
  return {
    orderActions: bindActionCreators(orderActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentStep);



// WEBPACK FOOTER //
// ./src/components/OrderModal/PaymentStep/PaymentStep.js